import { Location } from '@cobliteam/common-types';
import DeviceStatusCell from '@cobliteam/devices/src/containers/DataTableDevices/components/DeviceStatusCell';
import Icon from '@cobliteam/ui/icons';
import { date } from '@cobliteam/ui/utils';
import { deviceTypeLabel, getCategory, vehicleLabel } from '../../../helpers';
import { useSearch } from '../../../hooks/useSearch';
import { type DeviceWithCategory, EnumCategory } from '../../../types';
import CardHeader from '../../Cards/CardHeader';
import CardItem, { type CardItemProps } from '../../Cards/CardItem';
import CardMap from '../../Cards/CardMap';
const DevicesDetails = () => {
  const { data, selectedItem } = useSearch();
  const item = selectedItem as DeviceWithCategory;

  if (!item) return null;

  const vehicle = item?.vehicle;

  const vehicleCategory = getCategory(EnumCategory.VEHICLES);
  const driverCategory = getCategory(EnumCategory.DRIVERS);
  const groupsCategory = getCategory(EnumCategory.VEHICLE_GROUPS);

  if (!(vehicleCategory && driverCategory && groupsCategory)) return null;

  const cardVehicle: CardItemProps = {
    disabled: !vehicle,
    title: vehicle ? vehicle?.licensePlate || '---' : 'Sem veículo associado',
    subtitle: vehicleLabel(vehicle),
    tooltip: vehicle ? 'Veículo associado' : 'Nenhum veículo associado',
    icon: vehicleCategory.icon,
    color: vehicleCategory.color,
    itemLink: `${Location.VEHICLES}?search=${vehicle?.licensePlate}`,
    pageLink: `${Location.DEVICES}?search=${item.cobliId}`,
  };

  const cardDriver: CardItemProps = {
    disabled: !item.vehicle?.driver?.id,
    title: item.vehicle?.driver?.name || 'Sem motorista',
    tooltip: item.vehicle?.driver?.id ? 'Motorista associado' : 'Motorista não associado',
    subtitle: `Nº Telefone: ${item.vehicle?.driver?.phoneNumbers?.map((phone) => phone).join(', ') || '---'}`,
    icon: driverCategory.icon,
    color: driverCategory.color,
    itemLink: `${Location.DRIVER_MANAGEMENT}?search=${item.vehicle?.driver?.id}`,
    pageLink: undefined,
  };

  const cardGroups: CardItemProps = {
    disabled: !item.vehicle?.groups?.length,
    title: item.vehicle?.groups[0]?.name || 'Sem grupo',
    tooltip: item.vehicle?.groups?.length ? 'Grupo associado' : 'Nenhum grupo associado',
    icon: groupsCategory.icon,
    color: groupsCategory.color,
    itemLink: `${Location.VEHICLES_GROUPS}?search=${item.vehicle?.groups[0]?.id}`,
    pageLink: undefined,
  };

  const title = `${item.cobliId} `;
  const subtitle = deviceTypeLabel(item?.generalType);
  const tab = vehicle ? 'Associado' : 'Desassociado';

  return (
    <div className='relative flex h-[500px] w-full flex-col gap-4 overflow-hidden overflow-y-auto p-4'>
      <CardHeader
        icon={item.category.icon}
        color={item.category.color}
        title={title}
        subtitle={subtitle}
        link={`${Location.DEVICES}?search=${item.cobliId}&tab=${tab}`}
        linkTooltip='Ir para página de dispositivos'
      />

      {/*Details*/}
      <div className='grid grid-cols-12 gap-4'>
        <div className='col-span-12'>
          <div className='mb-1 flex items-center gap-2 font-medium text-xs'>
            <Icon name='info' className='!size-3' />
            Status do dispositivo:
          </div>
          <div className='ml-5 w-full'>
            <DeviceStatusCell device={item} size='sm' />
          </div>
        </div>
        <div className='col-span-12'>
          <div className='mb-1 flex items-center gap-2 font-medium text-xs'>
            <Icon name='info' className='!size-3' />
            Informações:
          </div>
          <div className='ml-5 w-full'>
            <div className='text-xs'>
              Última atualização: {item?.lastLocation?.cobliIngestedAt ? date.format(item?.lastLocation?.cobliIngestedAt, 'dd/MM/yyyy - HH:mm:ss') : '---'}
            </div>
          </div>
        </div>
      </div>

      {/*Cards*/}
      <div className=' space-y-2'>
        <CardItem {...cardVehicle} />
        <CardItem {...cardDriver} />
        <CardItem {...cardGroups} />
      </div>

      {/*Map*/}
      <div>
        <CardMap
          title='Última localização do dispositivo'
          latitude={item?.lastLocation?.latitude}
          longitude={item?.lastLocation?.longitude}
          updatedAt={item?.lastLocation?.cobliIngestedAt}
          linkTo={`/monitoring?search=${item?.vehicle?.licensePlate}&focus=true`}
        />
      </div>
    </div>
  );
};

export default DevicesDetails;
